module.exports = __webpack_public_path__ + "img/Silver.52b04f59.png";